export type Insight = {
  membersServed: number;
  executions: number;
  avgRuntimeMs: number;
};
export const EMPTY_INSIGHT: Insight = {
  membersServed: 0,
  executions: 0,
  avgRuntimeMs: 0,
};

export function formatAvgRuntime(ms: number): { value: string; unit: string } {
  if (ms <= 0) return { value: "0", unit: "s" };
  const s = ms / 1000;
  if (s < 10) {
    const v = (Math.round(s * 10) / 10).toFixed(1);
    return v === "10.0" ? { value: "10", unit: "s" } : { value: v, unit: "s" };
  }
  const total = Math.round(s);
  if (total < 60) return { value: String(total), unit: "s" };
  return { value: `${Math.floor(total / 60)}m ${total % 60}s`, unit: "" };
}

export function pickPersonalInsight(
  rows: Array<{ externalSubject: string } & Insight>,
  userId: string | undefined,
): Insight {
  if (!userId) return EMPTY_INSIGHT;
  const row = rows.find((r) => r.externalSubject === userId);
  return row
    ? {
        membersServed: row.membersServed,
        executions: row.executions,
        avgRuntimeMs: row.avgRuntimeMs,
      }
    : EMPTY_INSIGHT;
}
